'use strict';

var Resource_v1alpha1_schema = require('../schema/kinds/Resource.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const resourceEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(Resource_v1alpha1_schema.default);

exports.resourceEntityV1alpha1Validator = resourceEntityV1alpha1Validator;
//# sourceMappingURL=ResourceEntityV1alpha1.cjs.js.map
